<template lang="pug">
v-container
  v-card.pointer(v-if="availableYears.length" v-for="item in yearsList" :key="item.id" class="mx-auto mb-1" max-width="400" @click.native="goNext(item)")
    v-card-title {{ item }}
      span.ellipse.mg-act( v-if="hasNewAgreement && notViewedMyAgreement.some(el => el.year == item)" )
</template>
<script>
import { mapState, mapActions } from "vuex";


export default {
  name: 'ChooseAgreementYear',

  beforeMount() {
    this.loadAvailableYears()
  },

  computed: {
    ...mapState("agreement", ['availableYears', 'notViewedMyAgreement']),

    hasNewAgreement() {
      return this.notViewedMyAgreement && this.notViewedMyAgreement.length
    },

    yearsList() {
      let now = new Date();
      let currentYear = now.getFullYear();
      let currentMonth = now.getMonth();
      if(this.availableYears) {
        if (currentMonth <= 2) return this.availableYears.filter(year => year === currentYear || year === currentYear - 1);
        else return this.availableYears.filter(year => year === currentYear);
      }
      return []
      
    }
  },

  methods: {
    ...mapActions("agreement", ['loadAvailableYears']),
    goNext(item){
      this.$router.push(`/personalAccount/agreementyears/${item}/months`)
    },
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mg-act {
  margin-left: 5px;
  margin-bottom: 17px;
}
</style>